import React, { FC, ReactNode } from 'react'
import { Box } from '@pogokid/mui'
import { Headline } from '~m/designSystem/components/Headline'

interface ContentMainHeaderProps {
  heading: ReactNode
}

export const ContentMainHeader: FC<
  React.PropsWithChildren<ContentMainHeaderProps>
> = ({ heading, children, ...props }) => {
  return (
    <Box
      py={6}
      display={'flex'}
      flexDirection={'column'}
      alignItems={'center'}
      justifyContent={'center'}
      textAlign={'center'}
      minHeight={'20vh'}
      maxWidth="sm"
      mx={'auto'}
      {...props}
    >
      <Headline>{heading}</Headline>
      {children}
    </Box>
  )
}
